import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68f720c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-select" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择合同")

export function render(_ctx, _cache) {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_button = _resolveComponent("a-button")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_input, {
        class: "s-input",
        disabled: true,
        value: _ctx.valueName,
        placeholder: "请选择",
        onChange: _ctx.inputChange
      }, null, 8, ["value", "onChange"]),
      _createVNode(_component_a_button, {
        type: "primary",
        disabled: !_ctx.maintenanceProjectId,
        class: "s-btn",
        onClick: _ctx.showModal
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      title: "选择合同",
      width: "1100px",
      onCancel: _ctx.closeModal,
      onOk: _ctx.ok
    }, {
      default: _withCtx(() => [
        _createVNode(_component_table_wrapper, {
          dataSource: _ctx.dataSource.records,
          onOnTableChange: _ctx.onTableChange,
          onOnRadioChange: _ctx.onRadioChange,
          pagination: false,
          loading: _ctx.loading,
          columns: _ctx.columns,
          showRadiobox: true
        }, {
          type: _withCtx(({record}) => [
            _createElementVNode("span", null, _toDisplayString(record.type == "gcht" ? "工程合同" : "电子签合同"), 1)
          ]),
          _: 1
        }, 8, ["dataSource", "onOnTableChange", "onOnRadioChange", "loading", "columns"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}